var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormHelperText, Typography } from '@mui/material';
import { Checkbox, FormLayout, PhoneNumberInput, TextField } from 'hx-ui';
import { REGEX_NUMBERS_ONLY } from 'hx-util';
import { DisclaimerWithReadMore } from '@/components/disclaimer-with-read-more.component';
export var SpeakToAnExpertForm = function (_a) {
    var form = _a.form;
    var control = form.control;
    return (_jsxs(FormLayout, { children: [_jsx(TextField, { name: "first-name", control: control, rules: {
                    required: 'First Name is required',
                    minLength: {
                        value: 2,
                        message: 'First Name must be at least 2 characters',
                    },
                    maxLength: {
                        value: 26,
                        message: 'First Name must be less than 26 characters',
                    },
                }, label: "First Name", variant: "standard", required: true }), _jsx(TextField, { name: "last-name", control: control, rules: {
                    required: 'Last Name is required',
                    minLength: {
                        value: 2,
                        message: 'Last Name must be at least 2 characters',
                    },
                    maxLength: {
                        value: 26,
                        message: 'Last Name must be less than 26 characters',
                    },
                }, label: "Last Name", variant: "standard", required: true }), _jsx(TextField, { name: "email", control: control, rules: {
                    required: 'Email is required',
                    pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'Invalid email address',
                    },
                }, label: "Email", variant: "standard", required: true }), _jsx(PhoneNumberInput, { control: control, className: "min-w-[250px]", countrySelectProps: {
                    name: 'country-code',
                    variant: 'standard',
                    shouldRenderCountry: function (country) { return country.code === 'US'; },
                }, textFieldProps: {
                    variant: 'standard',
                    name: 'contact-number',
                    rules: {
                        required: 'Contact Number is required',
                        pattern: {
                            value: REGEX_NUMBERS_ONLY,
                            message: 'Contact Number must be numeric',
                        },
                        validate: function (value) {
                            if (value.length !== 10) {
                                return 'Contact Number must be  10 digits';
                            }
                        },
                    },
                    label: 'Contact Number',
                } }), _jsx(PreferredContactMethodGroup, { form: form }), _jsx(DisclaimerWithReadMore, {}), _jsx(Checkbox, { name: "consent", className: "min-w-full", control: control, rules: {
                    required: 'You need to give consent in order to continue',
                }, required: true, label: _jsx(Typography, __assign({ className: "italic font-bold" }, { children: "I Agree" })) })] }));
};
export default SpeakToAnExpertForm;
export var PreferredContactMethodGroup = function (_a) {
    var form = _a.form;
    var control = form.control, getFieldState = form.getFieldState, clearErrors = form.clearErrors;
    var error = getFieldState('notRegisteredInput').error;
    var validate = function () {
        var formValues = form.getValues();
        var preferredContactMethod = formValues['preferred-contact-method'];
        var hasAny = Object.values(preferredContactMethod).some(function (v) { return v; });
        if (!hasAny) {
            form.setError('notRegisteredInput', {
                type: 'required',
                message: 'Please select at least one contact method',
            });
        }
        else {
            clearErrors('notRegisteredInput');
        }
    };
    return (_jsxs("div", __assign({ className: "grid min-w-full gap-2" }, { children: [_jsx(Typography, __assign({ variant: "body1", className: "w-full text-start" }, { children: "Tell us your preferred method of contact:" })), _jsxs("div", __assign({ className: "flex flex-row flex-wrap justify-between w-full gap-1" }, { children: [_jsx(Checkbox, { name: "preferred-contact-method.email", control: control, rules: { validate: validate }, label: "Email" }), _jsx(Checkbox, { name: "preferred-contact-method.text-message", control: control, rules: { validate: validate }, label: "Text Message" }), _jsx(Checkbox, { name: "preferred-contact-method.voice-call", control: control, rules: { validate: validate }, label: "Voice Call" }), _jsx(Checkbox, { name: "preferred-contact-method.video-call", control: control, rules: { validate: validate }, label: "Video Call" })] })), error && _jsx(FormHelperText, __assign({ error: true }, { children: error.message }))] })));
};
